import { Logo } from '@/components/brand/Logo'
import { Demo, DsSection } from '../primitives'

export function LogoSection() {
  return (
    <DsSection id="logo" title="Logo" marketing>
      <div className="grid gap-6 md:grid-cols-2">
        <Demo
          label="Primary · theme black"
          className="border-ink-100 flex items-center rounded-sm border p-10"
        >
          <Logo theme="black" />
        </Demo>
        <Demo label="On dark · theme onDark" dark className="flex items-center p-10">
          <Logo theme="onDark" />
        </Demo>
      </div>
      <div className="grid gap-6 md:grid-cols-2">
        <Demo
          label="Small lockup · nav/footer scale"
          className="border-ink-100 flex items-center gap-8 rounded-sm border p-10"
        >
          <Logo size="small" width={64} />
          <Logo size="small" width={90} />
        </Demo>
        <Demo
          label="Symbol only · always safety green"
          className="border-ink-100 flex items-center gap-8 rounded-sm border p-10"
        >
          <Logo symbolOnly width={40} />
          <Logo symbolOnly width={64} />
        </Demo>
      </div>
    </DsSection>
  )
}
